import { checkSocialAuth } from './methods/check-social-auth'

/**
 * Auth service provides methods for working with social media authentication
 */
export const authService = {
  checkSocialAuth,
}

export {
  checkSocialAuth,
}
